<template>
  <div class="background">
    <RouterView />
    <BaseSnackbarContainer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useUserStore } from "@/store/user";
import BaseSnackbarContainer from '@/components/foundations/BaseSnackbarContainer.vue'

onMounted(async () => {
  if (useUserStore().token) {
    useUserStore().updateStore()
  }
})
</script>

<style lang="scss">
@import "../styles/main.scss";

.background {
  background: var(--background);
}
</style>
